import { mapGetters } from 'vuex';

export const invoiceMixin = {
    inheritAttrs: false,
    computed: {
        busy: {
            get() {
                return this.$store.getters['reservation/busy'];
            },
            set(newValue) {
                this.$store.commit('reservation/setBusy', newValue);
            },
        },
        redirectToInbox() {
            return this.isQuote;
        },
        controlPanelButtonLabel() {
            if (this.redirectToInbox) {
                return 'Unified Inbox';
            }
            return 'Control Panel';
        }
    },
    methods: {
        async fetchReservationInvoice(id) {
            try {
                await this.$store.dispatch('reservation/fetchReservationInvoice', { id: id });
            } catch (err) {
                this.errorToast({ text: 'Could not load reservation data.' });
            }
        },
        async refreshReservationInvoice(id) {
            this.busy = true;
            try {
                await this.fetchReservationInvoice(id);
            } finally {
                this.busy = false;
            }
        },
        goToControlPanel() {
            window.location = `/app/reservation/invoice/${this.reservationId}/control-panel/`;
        },        
    },
};
